import React, { Component } from 'react'
import { Batch } from './NewOrder';
import $ from 'jquery';
class BatchSelectionModal extends Component {

    SelectItem = async (lineNum) => {
        const { newOrderModel, refreshModel } = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum && ( !item.ItemBatchSelected)) {
                item.ItemBatchSelected = true;
            } else {
                item.ItemBatchSelected = false;
            }
        }
        await refreshModel(newOrderModel);
    }

    SelectAvailableBatch = async (lineNum, indexBatch, sysNum) => {
        const { newOrderModel, refreshModel } = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                for (let indez = 0; indez < item.AvailableBatchNumbers.length; indez++) {
                    const batch = item.AvailableBatchNumbers[indez];
                    if (indexBatch === indez && batch.SysNumber === sysNum) {
                        batch.selected = true;
                    } else {
                        batch.selected = false;
                    }
                }
            }
        }

        await refreshModel(newOrderModel);
    }

    SelectBatch = async (lineNum, indexBatch, sysNum) => {
        const { newOrderModel, refreshModel } = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                    const batch = item.BatchNumbers[indez];
                    if (indexBatch === indez && batch.SysNumber === sysNum) {
                        batch.selected = true;
                    } else {
                        batch.selected = false;
                    }
                }
            }
        }

        await refreshModel(newOrderModel);
    }

    ChangeQuantityBatch = async (value, lineNum, indexBatch, sysNum) => {
        const { newOrderModel, refreshModel, showAlert } = this.props;
        if (isNaN(value)) {
            return showAlert({ type: 'warning', message: `Cantidad invalida`, timeOut: 8000 });
        }
        if (value < 0) {
            return showAlert({ type: 'warning', message: `Cantidad invalida`, timeOut: 8000 });
        }

        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                for (let indez = 0; indez < item.AvailableBatchNumbers.length; indez++) {
                    const avBatch = item.AvailableBatchNumbers[indez];
                    if (indexBatch === indez && avBatch.SysNumber === sysNum) {
                        if (Number(value) > Number(avBatch.Quantity)) {
                            return showAlert({ type: 'warning', message: `Cantidad excedida`, timeOut: 8000 })
                        }
                        avBatch.SldQty = value;
                    }
                }
            }
        }

        await refreshModel(newOrderModel);
    }

    ValidateQuantityBatch = async (value, lineNum, sysNum) => {
        const { newOrderModel, refreshModel } = this.props;
        if (isNaN(value)) { value = ''; }
        else if (value <= 0) { value = ''; }
        else {
            value = Number(Number(value).toFixed(3))
            if (value <= 0) { value = ''; }
        }
        const item = newOrderModel.Items.find(({LineNum}) => LineNum === lineNum);
        
        if (!!item) {
            const batch = item.AvailableBatchNumbers?.find(({SysNumber}) => SysNumber === sysNum);
            if (!!batch) { batch.SldQty = value; }
        }

        await refreshModel(newOrderModel);
    }

    AddBatch = async (lineNum, avBatch) => {
        const { newOrderModel, refreshModel } = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                let extantBatch = item.BatchNumbers.find((batch) => batch.BatchNumber === avBatch.DistNumber && Number(batch.SysNumber) === Number(avBatch.SysNumber));
                const batchQty = Number(Number(avBatch.SldQty).toFixed(3));
                if (!extantBatch) {
                    let newBatch = new Batch();
                    newBatch.BatchNumber = avBatch.DistNumber;
                    newBatch.ManufacturerSerialNumber = avBatch.MnfSerial;
                    newBatch.InternalSerialNumber = avBatch.LotNumber;
                    newBatch.ExpiryDate = avBatch.ExpDate;
                    newBatch.ManufacturingDate = avBatch.MnfDate;
                    newBatch.AddmisionDate = avBatch.InDate;
                    newBatch.Location = avBatch.Location;
                    newBatch.Notes = avBatch.Notes;
                    newBatch.Quantity = Number(batchQty || 0);

                    newBatch.BaseLineNumber = lineNum;
                    newBatch.SysNumber = avBatch.SysNumber;

                    if (newOrderModel.AuxViewCounter && newOrderModel.AuxViewCounter === 'RefundModal') {
                        newBatch.newQuantity = Number(batchQty || 0) ?? 0;
                    }
                    item.BatchNumbers.push(newBatch);


                } else {
                    for (let index = 0; index < item.BatchNumbers.length; index++) {
                        const batch = item.BatchNumbers[index];
                        if (batch.BatchNumbers === avBatch.BatchNumbers && Number(batch.SysNumber) === Number(avBatch.SysNumber)) {
                            batch.Quantity = Number((Number(batch.Quantity || 0) + Number(batchQty || 0)).toFixed(3));
                        }
                    }
                }

                item.OpenLneQty = Number((Number(item.OpenLneQty || 0) - Number(batchQty || 0)).toFixed(3));
                item.SnBUoMQty = 0;

                for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                    const batch = item.BatchNumbers[indez];
                    item.SnBUoMQty = Number((Number(item.SnBUoMQty || 0) + Number(batch.Quantity || 0)).toFixed(3));
                }

                for (let indez = 0; indez < item.AvailableBatchNumbers.length; indez++) {
                    const batch = item.AvailableBatchNumbers[indez];
                    if (batch.DistNumber === avBatch.DistNumber && avBatch.SysNumber === batch.SysNumber) {
                        batch.Quantity = Number((Number(batch.Quantity || 0) - Number(batchQty || 0)).toFixed(3));
                        batch.SldQty = 0;
                    }
                    batch.selected = false;
                }

            }
        }

        await refreshModel(newOrderModel);
    }

    DeleteBatch = async (lineNum, deleteBatch) => {
        const { newOrderModel, refreshModel } = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                    const batch = item.BatchNumbers[indez];
                    if (batch.BatchNumber === deleteBatch.BatchNumber && batch.SysNumber === deleteBatch.SysNumber) {
                        item.BatchNumbers.splice(indez, 1);
                    }
                    batch.selected = false;
                }
                for (let indez = 0; indez < item.AvailableBatchNumbers.length; indez++) {
                    const avBatch = item.AvailableBatchNumbers[indez];
                    if (avBatch.DistNumber === deleteBatch.BatchNumber && deleteBatch.SysNumber === avBatch.SysNumber) {
                        avBatch.Quantity += Number(deleteBatch.Quantity);
                        avBatch.SldQty = 0;
                    }
                }
                item.OpenLneQty += Number(deleteBatch.Quantity);
                item.SnBUoMQty -= Number(deleteBatch.Quantity);
            }
        }
        await refreshModel(newOrderModel);

    }

    Cancel = async (lineNum) => {
        const { newOrderModel, refreshModel, ShowBatchSelectionModal } = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                item.BatchNumbers = [];
                item.SnBUoMQty = 0;
                item.OpenLneQty = item.Quantity;
            }
        }
        await refreshModel(newOrderModel);
        $('#batchSelectionModal').modal('hide');
        await ShowBatchSelectionModal();
    }

    Continue = async (option) => {
        const { ShowBatchSelectionModal, newOrderModel, CloseOpenRefundOfPaymentsModal } = this.props;
        $('#continueBatchSelectionModal').modal('hide');
        
        if (option) {
            $('#batchSelectionModal').modal('hide');
            if (newOrderModel.AuxViewCounter && newOrderModel.AuxViewCounter === 'RefundModal') {
                if (CloseOpenRefundOfPaymentsModal) await CloseOpenRefundOfPaymentsModal(true)
                await ShowBatchSelectionModal(false);
            }
            else {
                if (!newOrderModel.ReserveDelivery) { await ShowBatchSelectionModal(true); }
                else { await ShowBatchSelectionModal(false); }
            }
        }
    }

    nextDoc = async () => {
        const { newOrderModel, removeIncompleteBatchDoc, nextDocument } = this.props;
        let completeBatchs = false;
        let items = newOrderModel.Items || [];
        let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');

        for (let index = 0; index < itemsBatch.length; index++) {
            const item = itemsBatch[index];
            item.SnBUoMQty = 0;
            for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                const batch = item.BatchNumbers[indez];
                item.SnBUoMQty += Number(batch.Quantity);
            }
            if (item.SnBUoMQty !== 0) { completeBatchs = true; }
        }

        if (!completeBatchs) { await removeIncompleteBatchDoc(newOrderModel.DocEntry); }
        nextDocument();
    }

    Close = async () => {
        const { ShowBatchSelectionModal } = this.props;
        $('#batchSelectionModal').modal('hide');
        await ShowBatchSelectionModal(false);
    }

    validateTotalBatchsQuantity = () => {
        const { newOrderModel, showAlert } = this.props;
        let items = newOrderModel.Items || [];
        let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');

        for (let index = 0; index < itemsBatch.length; index++) {
            const item = itemsBatch[index];
            item.SnBUoMQty = 0;
            for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                const batch = item.BatchNumbers[indez];
                item.SnBUoMQty += Number(batch.Quantity);
            }
            if (Number(item.SnBUoMQty) !== Number(item.Quantity)) { return showAlert({ type: 'warning', message: `Complete la cantidad necesitada de todos los artículos`, timeOut: 8000 }) }
        }

        $('#continueBatchSelectionModal').modal('show');
    }

    ChangeFilterBatch = async (value, lineNum) => {
        const { newOrderModel, refreshModel } = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                item.FilterBatch = value;
            }
        }
        await refreshModel(newOrderModel);
    }

    render() {
        const { massiveDocs, newOrderModel } = this.props;
        return (
            <>
                <div className="modal fade" id="batchSelectionModal" data-keyboard="false" tabIndex="-1" aria-labelledby="batchSelectionModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header" style={{ background: "#343A40" }}>
                                <h5 style={{ color: "white" }}> Seleccion de lotes {massiveDocs ? `(Documento ${newOrderModel.DocNum})` : ""} </h5>
                                <button type="button" className="close" onClick={() => this.Close()} aria-label="Close" style={{ color: "white" }} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className='row'>
                                    <div className='col-12 p-4'>
                                        <h6><strong>Lineas del documento: </strong></h6>
                                        <div style={{ border: "1px solid #00000020", height: "18vh", overflowY: "scroll" }}>
                                            <table className="table response table-hover table-striped" style={{ marginBottom: 0 }}>
                                                <thead className='sticky-header' style={{ background: 'white' }}>
                                                    <tr>
                                                        <th scope="col">#</th>
                                                        <th scope="col">Artículo</th>
                                                        <th scope="col">Descripción</th>
                                                        <th scope="col">Almacén</th>
                                                        {/* <th className="text-center" scope="col" colSpan={2}>Almacén</th> */}
                                                        <th scope="col">Cantidad</th>
                                                        <th scope="col">Necesitado</th>
                                                        <th scope="col">Seleccionado</th>
                                                    </tr>
                                                </thead>
                                                {this.RenderBodyItemsBatch()}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 pl-4 pr-4'>
                                        <div className='row'>
                                            <div className='col-6 p-4'>
                                                <h5>Lotes disponibles</h5>
                                                <div className='mt-4' style={{ border: "1px solid #00000020", height: "31vh", overflowY: "scroll" }}>
                                                    <table className="table response table-hover table-striped" style={{ marginBottom: 0 }}>
                                                        <thead className='sticky-header' style={{ background: 'white' }}>
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th scope="col">Lote</th>
                                                                <th scope="col">Disponible</th>
                                                                <th scope="col">Cantidad Seleccionada</th>
                                                                <th scope="col">Caducidad</th>
                                                            </tr>
                                                        </thead>
                                                        {this.RenderAvailableBatchBody()}
                                                    </table>
                                                </div>
                                            </div>
                                            {this.RenderMoveButtons()}
                                            <div className='col-5 p-4'>
                                                <h5>Lotes seleccionados</h5>
                                                <div className='mt-4' style={{ border: "1px solid #00000020", height: "31vh", overflowY: "scroll" }}>
                                                    <table className="table response table-hover table-striped" style={{ marginBottom: 0 }}>
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th scope="col">Lote</th>
                                                                <th scope="col">Seleccionado</th>
                                                                <th scope="col">Número del sistema</th>
                                                            </tr>
                                                        </thead>
                                                        {this.RenderBatchBody()}
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.RenderFooterActions()}
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderValidation()}
            </>
        )
    }

    RenderBodyItemsBatch = () => {
        const { newOrderModel } = this.props;
        const items = newOrderModel.Items || [];
        let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
        return (
            <tbody>
                {itemsBatch.length > 0 &&
                    itemsBatch.map((item, index) => {
                        return (
                            <tr style={{ background: `${item.ItemBatchSelected ? '#FFF8D2' : 'white'}` }} onClick={() => this.SelectItem(item.LineNum)}>
                                <td>{index + 1}</td>
                                <td>{item.ItemCode}</td>
                                <td>{item.ItemName}</td>
                                <td>{item.WhsCode}</td>
                                <td>{item.Quantity}</td>
                                <td>{item.OpenLneQty}</td>
                                <td>{item.SnBUoMQty}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        )
    }

    RenderAvailableBatchBody = () => {
        const { newOrderModel } = this.props;
        let items = newOrderModel.Items || [];
        let itemSelected = items.find((item) => item.ItemBatchSelected === true);
        if (!itemSelected) {
            let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
            itemSelected = itemsBatch[0];
        }
        let availableBatchNumbers = itemSelected.AvailableBatchNumbers.length > 0 ? itemSelected.AvailableBatchNumbers : [];
        if (itemSelected.FilterBatch !== '0' && availableBatchNumbers.length > 0) {
            availableBatchNumbers = availableBatchNumbers.filter((batch) => itemSelected.FilterBatch === '1' ? batch.Quantity > 0 : batch.Quantity > 0);
        }

        return (
            <tbody>
                {availableBatchNumbers.length > 0 &&
                    availableBatchNumbers.map((batch, index) => {
                        return (
                            <tr style={{ background: `${batch.selected ? '#FFF8D2' : 'white'}` }}
                                onClick={() => this.SelectAvailableBatch(itemSelected.LineNum, index, batch.SysNumber)}>
                                <td>{index + 1}</td>
                                <td>{batch.DistNumber || ''}</td>
                                <td>{batch.Quantity || 0}</td>
                                <td><input type="text" value={batch.SldQty || ''} onChange={(event) => this.ChangeQuantityBatch(event.target.value, itemSelected.LineNum, index, batch.SysNumber)} onBlur={() => this.ValidateQuantityBatch(batch.SldQty,itemSelected.LineNum, batch.SysNumber)} /></td>
                                <td>{batch.ExpDate}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        )
    }

    RenderBatchBody = () => {
        const { newOrderModel } = this.props;
        let items = newOrderModel.Items || [];
        let itemSelected = items.find((item) => item.ItemBatchSelected === true);
        if (!itemSelected) {
            let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
            itemSelected = itemsBatch[0];
        }
        return (
            <tbody>
                {itemSelected.BatchNumbers.length > 0 &&
                    itemSelected.BatchNumbers.map((batch, index) => {
                        return (

                            <tr style={{ background: `${batch.selected ? '#FFF8D2' : 'white'}` }}
                                onClick={() => this.SelectBatch(itemSelected.LineNum, index, batch.SysNumber)}>
                                <td>{index + 1}</td>
                                <td>{batch.BatchNumber}</td>
                                <td>{batch.Quantity}</td>
                                <td>{batch.SysNumber}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        )
    }

    RenderMoveButtons = () => {
        const { newOrderModel } = this.props;
        let items = newOrderModel.Items || [];
        let itemSelected = items.find((item) => item.ItemBatchSelected === true);
        if (!itemSelected) {
            let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
            itemSelected = itemsBatch[0];
        }
        let isAvSelected = null;
        let isBaSelected = null;
        if (itemSelected) {
            isAvSelected = itemSelected.AvailableBatchNumbers.find((batch) => batch.selected ? batch.SldQty ? (Number(batch.SldQty) && Number(batch.SldQty) <= Number(itemSelected.OpenLneQty)) ? true : false : false : false);
            isBaSelected = itemSelected.BatchNumbers.find((batch) => batch.selected ? true : false);
        }

        return (
            <div className='col-1 text-center' style={{ marginTop: '17%' }}>
                {<button type="button" disabled={isAvSelected ? false : true} className="btn btn-outline-secondary" onClick={() => this.AddBatch(itemSelected.LineNum, isAvSelected)}>
                    <i className="fa fa-chevron-right" aria-hidden="true" />
                </button>}
                {<button type="button" disabled={isBaSelected ? false : true} className="btn btn-outline-secondary" onClick={() => this.DeleteBatch(itemSelected.LineNum, isBaSelected)}>
                    <i className="fa fa-chevron-left" aria-hidden="true" />
                </button>}
            </div>
        )
    }

    RenderFooterActions = () => {
        const { newOrderModel, massiveDocs } = this.props;
        let items = newOrderModel.Items || [];
        let itemSelected = items.find((item) => item.ItemBatchSelected === true);

        if (!itemSelected) {
            let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
            itemSelected = itemsBatch[0];
        }

        return (
            <>
                <div className='row'>
                    <div className='col-4 pl-4'>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <label className="input-group-text" for="inputGroupSelect01">Visualizar lotes disponibles</label>
                            </div>
                            <select className="custom-select" id="inputGroupSelect01" value={itemSelected.BatchFilter} onChange={(event) => this.ChangeFilterBatch(event.target.value, itemSelected.LineNum)}>
                                <option value="0">Todos</option>
                                <option value="1">Disponible</option>
                                {/* <option value="2">Sin Stock</option> */}
                            </select>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-5 mt-3 pl-4'>
                        {!massiveDocs ?
                            <button type="button" className="btn botonCorrect mr-4" onClick={() => this.Cancel(itemSelected.LineNum)}>Cancelar</button>
                            : <button type="button" className="btn botonCerrar text-white mr-4" onClick={this.nextDoc}>Omitir</button>
                        }
                        {this.RenderContinue()}
                    </div>
                    <div className='col-7'>

                    </div>
                </div>
            </>
        )
    }

    RenderContinue = () => {
        const { newOrderModel, massiveDocs } = this.props;
        let showContinue = false;
        let items = newOrderModel.Items || [];
        let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');

        for (let index = 0; index < itemsBatch.length; index++) {
            const item = itemsBatch[index];
            item.SnBUoMQty = 0;
            for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                const batch = item.BatchNumbers[indez];
                item.SnBUoMQty += Number(batch.Quantity);
            }
            if (item.SnBUoMQty !== 0) {
                showContinue = true;
            }
        }

        return (
            <>
                {showContinue ? (
                    !massiveDocs ? <button type="button" className="btn botonCorrect" onClick={this.validateTotalBatchsQuantity} >Continuar</button>
                    : <button type="button" className="btn botonCorrect" onClick={this.nextDoc} > Siguiente </button> ): ''}
            </>
        )
    }

    renderValidation() {

        return (
            <div className="modal" tabIndex="-1" role="dialog" id="continueBatchSelectionModal" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <p>¿Deseas continuar?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={() => this.Continue(true)}> Si </button>
                            <button type="button" className="btn botonCorrect text-black" onClick={() => this.Continue(false)}>No</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default BatchSelectionModal
